import React, {useState} from "react";
import { usePinMessageMutation } from "../api/chatApi";
import Toast from "../../../components/ToastNotification";

const PinDurationModal = ({ onClose, selectedMessage }) => {
    const [selectedValue, setSelectedValue] = useState(604800);
    const {user_id, recipient, message_id, is_pinned} = selectedMessage;

    const pinOptions = [
        { label: "24 hours", value: 86400 },
        { label: "7 days", value: 604800 },
        { label: "30 days", value: 2592000 }
    ];
    const [pinMessageApi] = usePinMessageMutation();

    const handlePinMessage = async() => {
        try {
            const res = await pinMessageApi({
                user_id, 
                remote_jid: recipient, 
                message_key: message_id, 
                type: is_pinned ? "UNPIN_FOR_ALL" : "PIN_FOR_ALL",
                duration: selectedValue
            }).unwrap();

            Toast.success(res.message);
            onClose();
        } catch (error) {
            Toast.error(error.data.message)
        }
    }

    return (
        <div className="pin-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Choose how log your pin lasts</h3>
            <h4>You can unpin at any time</h4>

            {pinOptions.map(opt => (
                <label key={opt.value} className="modal-option">
                    <input
                        type="radio"
                        checked={selectedValue === opt.value}
                        onChange={() => setSelectedValue(opt.value)}
                    />
                    <span>{opt.label}</span>
                </label>
            ))}

            <div className="pin-actions">
                <button id="cancel-btn" onClick={onClose}>Cancel</button>
                <button className="submit-btn" onClick={handlePinMessage}>Pin</button>
            </div>
        </div>
    );
};

export default PinDurationModal;
